import { Heading } from '@chakra-ui/react'
import React from 'react'
import Navbar from '../Navbar'

export default function Studio() {
  return (
    <>
        <Navbar/>
        <Heading>Studio</Heading>
        
    </>
  )
}
